export default {
    PENDING: 1,
    SUCCESS: 2,
    FAIL: 3,
    CANCELLED: 4,
};
